/// <reference path="../app.ts" />
namespace Advant.Crossroads {
    "use strict";

    interface ICfncDirectAdmission extends angular.IDirective {
    }

    interface ICfncDirectAdmissionScope extends angular.IScope {
        ceebCode: string;
        highSchoolNameField: any;
        dpiNumberField: any;
        redirectUrl: string;
    }

    interface ICfncDirectAdmissionAttributes extends angular.IAttributes {
        studentNumberField: string;
        lastNameField: string;
        highSchoolNameField: any;
        dpiNumberField: any;
        dateOfBirthField: any;
        participantField: any;
        disableRedirection: any;
        ceebCode: string;
        redirectUrl: string;
        user: string;
        advResponse: any;
        title: string;
        cssClass: string;
        ngModel: string;
    }

    cfncDirectAdmission.$inject = ["$parse", "helper", "Restangular", "config", "$window", "$document", "$cookies", "$routeParams"];
    function cfncDirectAdmission($parse: angular.IParseService, helper: IHelper, Restangular: Restangular.IService, config: Advant.Crossroads.ICrossroadsConfig,
        $window: angular.IWindowService, $document: angular.IDocumentService, $cookies: angular.cookies.ICookiesService, $routeParams: IApplicationRouteParams): ICfncDirectAdmission {
        var checkEligibility = (studentNumber: any, lastName: any, scope: any, ctrl: any, attrs: any) => {
            
            var params = { studentNumber: studentNumber, lastName: lastName, application: $routeParams.organization + "/" + $routeParams.program + "/" + $routeParams.application };
            if (studentNumber != null && lastName != null) {
                Restangular.one("userApplications/getDirectAdmissionEligibility").get(params).then((result) => {
                    scope.ceebCode = result.ceebCode;
                    ctrl.$modelValue = result.ceebCode;
                    ctrl.$viewValue = result.ceebCode;
                    ctrl.$render();
                    $parse(attrs.highSchoolNameField).assign(scope, result.highSchoolName);
                    $parse(attrs.dpiNumberField).assign(scope, result.dpiNumber);
                    if (result.dateOfBirth != null)
                        $parse(attrs.dateOfBirthField).assign(scope, result.dateOfBirth);
                    $parse(attrs.ngModel).assign(scope, result.ceebCode);
                    var cookie = $cookies.get("CollegeConnectOrigin");
                    if (cookie) {
                        $parse(attrs.participantField).assign(scope, "Yes");
                        $cookies.remove("CollegeConnectOrigin", { path: '/' });
                    }

                    if (result.ceebCode != null) {
                        ctrl.$setValidity("required", true);
                        $document.find("[ng-model='" + attrs.dateOfBirthField + "']").attr("disabled", "disabled");
                        $document.find("[ng-model='" + attrs.lastNameField + "']").attr("disabled", "disabled");
                        $document.find("[ng-model='" + attrs.studentNumberField + "']").attr("disabled", "disabled");
                    }
                    else {
                        if (!angular.isDefined(attrs.disableRedirection)) {
                            var test = attrs.redirectUrl.toString();
                            var url = _.isEmpty(test) ? config.cfncUrl + "/collegeConnect" : test;
                            $window.location.href = url;
                        }
                    }
                }, (reason) => {
                });
            }
        };

        var link = (scope: ICfncDirectAdmissionScope, element: angular.IAugmentedJQuery, attrs: ICfncDirectAdmissionAttributes, ctrl: angular.INgModelController) => {
            if (!ctrl) { return; }

            var lastName: string = $parse(attrs.lastNameField)(scope);
            var studentNumber: string = $parse(attrs.studentNumberField)(scope);
            var user: IUser = $parse(attrs.user)(scope);
            var params = { studentNumber: studentNumber, lastName: lastName };
            if (studentNumber != null && lastName != null) {
                checkEligibility(studentNumber, lastName, scope, ctrl, attrs);
            }
            else
            {
                checkEligibility(user.studentNumber, user.name.last, scope, ctrl, attrs);
            }

            scope.$watch(attrs.studentNumberField, (newValue: any) => {
                studentNumber = newValue;
                checkEligibility(studentNumber, lastName, scope, ctrl, attrs);
            });

            scope.$watch(attrs.lastNameField, (newValue: any) => {
                lastName = newValue;
                checkEligibility(studentNumber, lastName, scope, ctrl, attrs);
            });

            //(ctrl.$validators as any) = (modelValue, viewValue) => {
            //    return ctrl.$isEmpty(modelValue) || scope.ceebCode == null;
            //};
        };

        return {
            restrict: "A",
            require: "?ngModel",
            priority: -1,
            link: link,
            replace: true,
        }

    }

    angular.module("app").directive("cfncDirectAdmission", cfncDirectAdmission);
}